import {createSelector} from 'reselect'
import get from 'lodash/get';
import {NetWorthDonutChart} from '../../js/app/react/chartDescriptors.overview'

export const is_initialized = (state) => state.NetWorth.is_initialized

export const nullableClientChartSelector = createSelector(
  state => state,
  (_, { clientId }) => clientId,
  (_, { type }) => type,
  (state, clientId, type) => (
    get(state, `NetWorthDonutChart[${clientId}][${type}].chart`, null)
  ),
);

export const chartTotalOrDefaultSelector = createSelector(
  nullableClientChartSelector,
  clientChart => (clientChart ? clientChart.Balance : 0) || 0,
);

export const get_chart_data = createSelector(
    [
      nullableClientChartSelector,
      (state, { isPrint }) => (isPrint || false),
    ],
    (chart, isPrint) => {
        if (chart === null || Object.keys(chart).length < 1) return

        let chart_data = clone(NetWorthDonutChart),
            series_data = [],
            colors = ADV.settings.colors.concat(ADV.settings.color_groups[0].slice(0, 8))

        chart.Categories.forEach(function (category) {
            let value = parseInt(category.Balance, 10)
            if (value)
                series_data.push({"name": category.Category, "y": value});
        });

        chart_data.series[0].data = series_data
        chart_data.hide_chart = series_data.length === 0
        chart_data.colors = colors

        if (isPrint) {
            chart_data.series.forEach((series) => series.animation = false)
        }
        return chart_data
    })
